import { useState } from 'react';
import { testimonials } from '@/mocks/comics';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  const goNext = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const goPrev = () =>
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
            <div className="w-full lg:w-[40%]">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-accent-100">
                <img
                  src={t.avatar}
                  alt={`${t.name} 读者头像`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="w-full lg:w-[60%] flex flex-col justify-center">
              <span className="text-xs font-medium text-primary-500 tracking-wider mb-3">
                （读者好评）
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
                百万读者的
              </h2>
              <p className="text-2xl md:text-3xl font-bold text-foreground-300 font-heading mb-8">
                共同选择
              </p>

              <blockquote className="mb-8">
                <p className="text-base md:text-lg text-foreground-600 leading-relaxed italic">
                  「{t.content}」
                </p>
              </blockquote>

              <div className="flex items-center gap-4">
                <div className="w-8 h-px bg-primary-500"></div>
                <strong className="text-sm font-semibold text-foreground-950">
                  {t.name}
                </strong>
                <div className="flex gap-0.5">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
              </div>

              <div className="flex items-center gap-3 mt-10">
                <button
                  type="button"
                  onClick={goPrev}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-500 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all cursor-pointer"
                  aria-label="上一条评价"
                >
                  <i className="ri-arrow-left-s-line text-lg"></i>
                </button>
                <button
                  type="button"
                  onClick={goNext}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-all cursor-pointer"
                  aria-label="下一条评价"
                >
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </button>
                <span className="text-xs text-foreground-400 ml-2">
                  {current + 1} / {testimonials.length}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}